export const ORDER_FETCHED = "RaasOrderItemListingScreen/ORDER_FETCHED";
export const RAAS_ORDER_ITEM_CONSTANTS_FETCHED = "RaasOrderItemListingScreen/ORDERS_CONSTANTS_FETCHED";